function SIgnOut() {
    localStorage.clear();
    window.location.href='/';
    return (
        <> </>
    )
}

export default SIgnOut;